export default "__VITE_ASSET__BONaWLIm__"